export const removeDashesFromString = (inputString = '') => {
  if (!inputString || typeof inputString !== 'string') return '';

  return inputString.replace(/-/g, "");
}